// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/accordion_image/accordion_image.js';
import '../../flex/content/layouts/distributor_search/distributor_search.js';
import '../../flex/content/layouts/heroes_slider/heroes_slider.js';
import '../../flex/content/layouts/image_text_cards/image_text_cards.js';
import '../../flex/content/layouts/industry_slider/industry_slider.js';
import '../../flex/content/layouts/product_explorer/product_explorer.js';
